export default "__VITE_ASSET__92cfc17b__"